import React from 'react';
import PropTypes from 'prop-types';
import { Table, TableContainer, TableHead, TableRow,
         TableCell, TableBody, Typography, withStyles
} from "@material-ui/core";
import moment from "moment-timezone";
import guid from './../../../../utils/guid';
import NoData from './../../../Common/NoDataRow';
import useStyles from "./tabStyles";
import t from "../../../../languages/pl";
import { displayDateTimeFormat } from './../../../../utils/staticData';

const WarningTab = props => {
    const { classes, warnings } = props;

    const generateRouteDetailsTable = data => {
        if (!data || data.length === 0)
            return <NoData colSpan={3} />;
        return data.map(row => {
            return (
                <TableRow key={guid()}>
                    <TableCell className={classes.tableCell}>
                        <Typography variant="body1">
                            {moment.unix(row.data).format(displayDateTimeFormat)}
                        </Typography>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                        <Typography variant="body1">
                            {row.typ}
                        </Typography>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                        <Typography variant="body1">
                            {row.zdarzenie}
                        </Typography>
                    </TableCell>
                </TableRow>
            );
        });
    };

    return (
        <TableContainer className={classes.tableContainer}>
            <Table stickyHeader>
                <TableHead>
                    <TableRow >
                        <TableCell className={classes.tableCell}>
                            <Typography variant="body1">
                                {t.date}
                        </Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                            <Typography variant="body1">
                                {t.type}
                        </Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                            <Typography variant="body1">
                                {t.incident}
                        </Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {generateRouteDetailsTable(warnings)}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

WarningTab.propTypes = {
    classes: PropTypes.object,
    warnings: PropTypes.array
};

export default withStyles(useStyles)(WarningTab);
